import { observer } from "mobx-react-lite";
import { authStore, userStore } from "../stores";
import { Collapse, Drawer } from "antd";
import { CommunicationLanguage } from "../api";
import { MyColor } from "../config/myStyle";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export type MyDrawerProps = { open?: boolean; onClose?(): void };
export const MyDrawer = observer((props: MyDrawerProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const go = (path: string) => {
    navigate(path);
    props.onClose?.();
  };
  const link = (label: string, path: string) => (
    <button
      type="button"
      className="menu-link text-left"
      onClick={() => go(path)}
    >
      {t(label)}
    </button>
  );
  // 根据当前语言和登录状态直接生成菜单，避免缓存造成翻译或退出项失效。
  const groups = [
    {
      key: "donate",
      title: "drawer.donate",
      child: "drawer.support_fundraising_event",
      path: "/donation",
    },
    {
      key: "create",
      title: "drawer.host_fundraiser",
      child: "drawer.create_campaign",
      path: "/campaign/create",
    },
  ];
  return (
    <Drawer
      open={props.open}
      onClose={props.onClose}
      size={10000}
      closable={{ "aria-label": t("drawer.close_menu"), placement: "start" }}
      title={
        <div className="flex justify-end gap-[12px]">
          {(
            [
              { title: "EN", key: "en" },
              { title: "繁", key: "zh-HK" },
              { title: "簡", key: "zh-CN" },
            ] as { title: string; key: CommunicationLanguage }[]
          ).map((item) => (
            <button
              type="button"
              key={item.key}
              className="menu-link"
              aria-pressed={userStore.language === item.key}
              style={{ opacity: userStore.language === item.key ? 1 : 0.5 }}
              onClick={() => userStore.setLanguage(item.key)}
            >
              {item.title}
            </button>
          ))}
        </div>
      }
    >
      <nav
        aria-label={t("drawer.open_menu")}
        className="fa-menu flex flex-col gap-[12px] text-[18px] text-[#676867]"
      >
        {link("drawer.home", "/")}
        {link("drawer.my_record", "/my-record")}
        {/* 捐款与发起筹款同级，各保留一个子入口；旧一般筹款不再显示。 */}
        {groups.map((group) => (
          <Collapse
            key={group.key}
            ghost
            defaultActiveKey={[group.key]}
            expandIconPlacement="end"
            styles={{
              header: { padding: 0, paddingBottom: 10, width: "fit-content" },
              title: { color: MyColor.red, fontSize: 18 },
              body: { padding: 0, marginLeft: 24 },
            }}
            items={[
              {
                key: group.key,
                label: t(group.title),
                children: (
                  <div className="text-[18px]">
                    {link(group.child, group.path)}
                  </div>
                ),
              },
            ]}
          />
        ))}
        {link("drawer.contact_us", "/contact-us")}
        {authStore.loggedIn ? (
          <button
            type="button"
            className="menu-link text-left"
            onClick={() => {
              authStore.logout();
              userStore.userData = undefined;
              props.onClose?.();
            }}
          >
            {t("drawer.logout")}
          </button>
        ) : (
          link("drawer.login", "/login")
        )}
      </nav>
    </Drawer>
  );
});
